export const scrollTo = (elementId: string) => {
  const voucherShowCase = document.getElementById(elementId);

  if (voucherShowCase) {
    const padding = 40;
    const top =
      voucherShowCase.getBoundingClientRect().top + window.scrollY - padding;

    window.scrollTo({
      top,
      behavior: 'smooth',
    });
  }
};
